import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  zipCodes: null,
  status: 'idle',
  error: null,
};

const zipCodesSlice = createSlice({
  name: 'zipCodesApi',
  initialState,
  reducers: {
    setZipCodes: (state, action) => {
      state.zipCodes = action.payload;
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setZipCodes, setError, setLoading } = zipCodesSlice.actions;
export default zipCodesSlice.reducer;
